import en from './en'
import de from './de'
import es from './es'
import fr from './fr'
import ru from './ru'
import ja from './ja'

export default { en, de, es, fr, ru, ja }
